function getImageUrl(path) {
    const baseUrl = window.API_HOST_URL;
    const defaultImage = `${baseUrl}/media/default/default_img.jpg`;

    // null / undefined
    if (!path) {
        return defaultImage;
    }

    // If array
    if (Array.isArray(path)) {
        if (path.length === 0) {
            return defaultImage;
        }

        // take first image object
        path = path[0].small_thumb || path[0].image;
    }

    // If object
    if (typeof path === 'object' && path !== null) {
        path = path.small_thumb || path.image;
    }

    // Final safety check
    if (typeof path !== 'string') {
        return defaultImage;
    }

    return path.startsWith('http')
        ? path
        : `${baseUrl}${path}`;
}

export {
    getImageUrl,
}
